import { Stack, Box, Typography } from "@mui/material";
import {
  DatagridConfigurable,
  List,
  NumberField,
  TextField,
  DateField,
  NumberInput,
  ReferenceInput,
  SelectInput,
  FunctionField,
  DateInput,
} from "react-admin";
import { ContactEmpty } from "./ContactEmpty";

const optionCompaniesRenderer = (choice: any) =>
  `${choice.id} - ${choice.nome_reduzido}`;

const filters = [
  <DateInput source="dataini" label="Data Inicial" />,
  <DateInput source="datafim" label="Data Final" />,
  <NumberInput source="dias_alteracao" label="Dias Alteração" />,
  <ReferenceInput
    label="Empresa"
    source="id_empresa"
    reference="companies"
    perPage={100}
    sort={{ field: "id", order: "ASC" }}
    filter={{ todas: true }}
    fullWidth
  >
    <SelectInput
      optionText={optionCompaniesRenderer}
      label="Empresa"
      InputLabelProps={{ shrink: true }}
    />
  </ReferenceInput>,
  <NumberInput source="codigo_sku" label="SKU" />,
];

export function ScmProjectionLogs() {
  return (
    <Stack gap={4}>
      <List
        filters={filters}
        sort={{ field: "id", order: "DESC" }}
        perPage={50}
        exporter={false}
        empty={<ContactEmpty />}
      >
        <DatagridConfigurable
          bulkActionButtons={false}
          sx={{
            "& .column-descricao": { width: "100px" },
          }}
        >
          <NumberField
            source="codigo_sku"
            label="SKU"
            options={{ useGrouping: false }}
          />
          <DateField
            source="data_hora"
            showTime
            label="Data/Hora"
            fontSize="small"
          />
          <FunctionField
            //<ScmAnalyses>
            label="Empresa"
            sortBy="id_empresa"
            render={(record: any) => (
              <div>
                <NumberField
                  source="id_empresa"
                  fontSize="small"
                  options={{
                    useGrouping: false,
                  }}
                />
                {record?.nome_reduzido ? ". " : ""}
                <TextField source="nome_reduzido" fontSize="small" />
              </div>
            )}
          />
          <NumberField source="nova_sazo" label="Sazo" fontSize="small" />
          <NumberField source="nova_camp" label="Camp" fontSize="small" />
          <NumberField source="novo_esmin" fontSize="small" label="ESMin" />
          <NumberField
            source="novo_cmmf_quantidade"
            fontSize="small"
            label="CMMF"
          />
          <DateField source="novo_cmmf_validade" label="CMM Validade" />
          <TextField source="nome_usuario" label="Usuário" fontSize="small" />
        </DatagridConfigurable>
      </List>
    </Stack>
  );
}
